


  
  

  var faExpandRight = {
    prefix: 'fak',
    iconName: 'expand-right',
    icon: [
      316,
      512,
      [],
      'e001',
      
      'M288.3 279.4L106.8 480.3c-12.5 13.9-32.8 13.9-45.2 0L31.4 446.9c-12.5-13.9-12.5-36.3 0-50.1L160.1 254.4 31.4 112c-12.5-13.9-12.5-36.3 0-50.1L61.6 28.5c12.5-13.9 32.8-13.9 45.2 0L288.3 229.4c12.5 13.6 12.5 36 0 49.9z'
      
    ]
  };

  

  
  

  var faIlPlusBrand = {
    prefix: 'fak',
    iconName: 'il-plus-brand',
    icon: [
      539,
      512,
      [],
      'e000',
      
      'M134 254.1c-18.3 0-33.3-14.6-33.3-33.3V33.3C100.8 15 115.7 0 134 0s33.3 15 33.3 33.3v188c0 18.3-14.6 33.3-33.3 32.9zM6.8 126.9c0-18.3 14.6-33.3 33.3-33.3H228c18.3 0 33.3 15 33.3 33.3s-15 33.3-33.3 33.3H39.6c-18.3 0-32.9-14.6-32.9-33.3zM296.2 508.3c-36.6 0-66.1-29.5-66.1-66.1v-188c0-36.6 29.5-66.1 66.1-66.1s66.1 29.5 66.1 66.1v188c0 36.6-29.5 66.1-66.1 66.1zm156.4 0c-36.6 0-66.1-29.5-66.1-66.1V66.1C386.5 29.5 416 0 452.6 0s66.1 29.5 66.1 66.1v376c0 36.6-29.5 66.1-66.1 66.1zm-313.2 0a66.1 66.1 0 1 0 0-132.3 66.1 66.1 0 1 0 0 132.3z'
      
    ]
  };

  

  
  

  var faMypathBrand = {
    prefix: 'fak',
    iconName: 'mypath-brand',
    icon: [
      448,
      512,
      [],
      'e003',
      
      'M192.5 510.9c-17.1 0-34-6.4-47-19.4c-26-26-26-68 0-94L287.1 255.8 145.6 114.2c-26-26-26-68 0-94s68-26 93.9 0L428.1 208.8c26 26 26 68 0 94L239.5 491.4c-13 13-29.9 19.4-47 19.4zM66.7 322.1a66.4 66.4 0 1 0 0-132.8 66.4 66.4 0 1 0 0 132.8z'
      
    ]
  };

  

  
  

  var faPendoQuestion = {
    prefix: 'fak',
    iconName: 'pendo-question',
    icon: [
      512,
      512,
      [],
      'e004',
      
      'M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM167.2 201.5c0-11.3 3.7-22.8 10.9-34.3c7.2-11.7 17.8-21.3 31.8-28.9c13.9-7.6 30.2-11.4 48.7-11.4c17.3 0 32.5 3.2 45.7 9.6c13.3 6.3 23.4 14.9 30.5 25.9c7.2 11 10.9 22.9 10.9 35.7c0 10.1-2.1 19-6.2 26.6c-4 7.6-9 14.3-14.6 19.8c-5.6 5.5-15.7 14.7-30.4 27.9c-4 3.7-7.3 6.9-9.8 9.8c-2.4 2.7-4.2 5.3-5.4 7.7c-1.2 2.3-2.1 4.6-2.8 6.9c-.6 2.3-1.6 6.3-2.8 12.2c-2.3 12.3-9.3 18.6-21.2 18.6c-6.2 0-11.4-2-15.7-6c-4.2-4-6.2-10.1-6.2-18c0-10 1.6-18.7 4.7-25.9c3.1-7.4 7.2-13.8 12.3-19.3c5.1-5.6 12.1-12.2 20.8-19.8c7.6-6.7 13.1-11.7 16.5-15c3.5-3.5 6.3-7.2 8.6-11.4c2.4-4.2 3.6-8.7 3.6-13.5c0-9.5-3.6-17.6-10.7-24.1c-7-6.6-16.1-9.8-27.3-9.8c-13.1 0-22.8 3.3-28.9 10c-6.2 6.6-11.4 16.3-15.7 29.1c-4 13.4-11.7 20.2-23 20.2c-6.7 0-12.3-2.3-17-6.9c-4.5-4.8-6.8-9.9-6.8-15.4zm87.1 195.7c-7.2 0-13.6-2.3-19.1-6.9c-5.4-4.8-8-11.3-8-19.8c0-7.5 2.7-13.8 7.9-18.9s11.7-7.7 19.3-7.7s13.8 2.6 18.9 7.7s7.7 11.4 7.7 18.9c0 8.3-2.7 14.9-8 19.7s-11.5 7.1-18.6 7.1z'
      
    ]
  };

  



export {

  faExpandRight,
  

  faIlPlusBrand,
  

  faMypathBrand,
  

  faPendoQuestion,
  

};
